<template>
  <div id="PCtop" :style="lineStyle">
    <div class="wrap">
      <div class="left">
        <div class="line"><img :src="`${publicPath}img/pc/hearts_line.gif`"></div>
        <div class="title"><img :src="`${publicPath}img/pc/title.png`"></div>
        <div class="line"><img :src="`${publicPath}img/pc/hearts_line.gif`"></div>
      </div>
      <div class="right">
        <div class="flower1"><img :src="`${publicPath}img/pc/flower.png`"></div>
        <div class="flower2"><img :src="`${publicPath}img/pc/flower.png`"></div>
        <div class="chara1"><img :src="`${publicPath}img/pc/chara_kaguya.gif`"></div>
        <div class="chara2"><img :src="`${publicPath}img/pc/chara_shirogane.gif`"></div>
        <p>アクセスはコチラから！</p>
        <div class="qrcode"><img :src="`${publicPath}img/pc/qrcode.png`"></div>
        <div class="frame">
          <div class="inner">
            <div class="corner tl" :style="cornerStyle"></div>
            <div class="corner tr" :style="cornerStyle"></div>
            <div class="corner bl" :style="cornerStyle"></div>
            <div class="corner br" :style="cornerStyle"></div>
            このサイトは、<span>スマホ専用</span>とさせて<br>いただいております。
          </div>
        </div>
      </div>
    </div>
    <div class="footer">
      <div class="logo"><img :src="`${publicPath}img/pc/logo.png`"></div>
      <p>&copy;赤坂アカ／集英社 Copyright &copy; SHUEISHA Inc. All rights reserved.</p>
    </div>
  </div>
</template>

<script>
  // import _$ from 'jquery'

  export default {
    name: 'PCtop',
    components: {
    },
    props: {
    },
    data() {
      return {
        // 変更不可 -------------------------
        publicPath: process.env.BASE_URL,
        // ---------------------------------

        lineStyle: {
          backgroundImage: 'url(./img/pc/bg_line.png), url(./img/pc/bg_line.png)'
        },
        cornerStyle: {
          backgroundImage: 'url(./img/pc/frame_corner.png)'
        }
      }
    },
    mounted() {
      
    },
    destroyed () {
    },
    watch: {

    },
    computed: {

    },
    methods: {

    }
  }
</script>

<style lang="scss" scoped>
  #PCtop {
    background-position: center top, center bottom;
    background-repeat: repeat-x, repeat-x;
    width: 100%;
    height: 100%;
    min-height: 605px;
    background-color: #000;
    color: #fff;
    font-size: 16px;
    padding: 32px 0;

    .wrap {
      height: calc(100% - 110px);
      min-height: 431px;
      display: flex;
      justify-content: center;
      align-items: center;

      .left {
        text-align: center;
        margin-right: 80px;
        flex-shrink: 0;

        .line {
          height: 51px;
        }

        .title {
          margin: 17px auto 22px;
        }
      }

      .right {
        width: 410px;
        position: relative;
        text-align: center;
        flex-shrink: 0;

        p {
          line-height: 16px;
          margin-bottom: 16px;
        }

        .flower1 {
          position: absolute;
          top: 0;
          left: 0;
        }

        .flower2 {
          position: absolute;
          top: 0;
          right: 0;
          transform: scale(-1, 1);
        }

        .chara1 {
          position: absolute;
          top: 95px;
          left: 0;
        }

        .chara2 {
          position: absolute;
          top: 93px;
          right: 0;
        }

        .frame {
          margin-top: 19px;
          border: $COLOR_PINK02 5px solid;

          .inner {
            border: $COLOR_PINK01 5px solid;
            padding: 26px 55px;
            line-height: 1.75em;
            letter-spacing: 0.05em;
            text-align: left;
            position: relative;

            .corner {
              width: 15px;
              height: 15px;
              position: absolute;

              &.tl {
                top: -10px;
                left: -10px;
              }
              &.tr {
                top: -10px;
                right: -10px;
                transform: rotate(90deg);
              }
              &.bl {
                bottom: -10px;
                left: -10px;
                transform: rotate(-90deg);
              }
              &.br {
                bottom: -10px;
                right: -10px;
                transform: rotate(180deg);
              }
            }

            span {
              color: $COLOR_PINK01;
            }
          }

        }
      }
    }

    .footer {
      border-top: $COLOR_PINK01 4px solid;
      color: #777;
      font-family: "ヒラギノ角ゴ Pro W3", "Hiragino Kaku Gothic Pro", "メイリオ", Meiryo, Osaka, "ＭＳ Ｐゴシック", "MS PGothic", "sans-serif";
      font-size: 10px;
      text-align: center;
      line-height: 10px;
      width: 100%;
      padding: 26px 0;

      p {
        margin-top: 10px;
      }
    }
  }
</style>